import { Component } from '@angular/core';

@Component({
  selector: 'app-reposicion-asistida',
  templateUrl: './reposicion-asistida.component.html'
})
export class ReposicionAsistidaComponent {
  sucursalesSeleccionadas: string[] = [];

  actualizarSucursales(seleccionadas: string[]) {
    this.sucursalesSeleccionadas = seleccionadas;
  }
}
